import styled from "styled-components";

export const Container = styled.div`
  max-width: 900px;
  margin: 0 auto;

  /* background-color: red; */
`;

export const SingleCard = styled.div`
  display: flex;
  align-items: center;
  padding: 30px;
  background-color: #f5f4f1;
  border-radius: 20px;
  margin: 1em 0;
  /* box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05); */
  &:nth-child(odd) {
    flex-direction: row-reverse;
  }
  @media (max-width: 576px) {
    flex-direction: column;
    text-align: center;
    gap: 1rem;

    &:nth-child(odd) {
      flex-direction: column;
    }
  }
`;

export const IconContainer = styled.div`
  flex: 0 1 auto;
  margin-right: 20px;

  img {
    width: 10em;
    height: auto;
  }

  @media (max-width: 576px) {
  }
`;

// export const Image = styled.div`
//   flex: 0 1 200px;
//   margin-right: 20px;

//   img {
//     border-radius: 5px;
//     width: 100%;
//     height: auto;
//   }

//   @media (max-width: 576px) {
//     justify-content: center;
//     margin-right: 0;

//     img {
//       width: 100%;
//       height: auto;
//     }
//   }
// `;

export const Content = styled.div`
  flex: 1;

  @media (max-width: 576px) {
    order: 1;
  }
`;

export const Title = styled.h2`
  font-size: 24px;
  color: #1f3d2b;
  margin: 0;
  font-weight: bold;
`;

export const Description = styled.p`
  font-size: clamp(18px, 1.5vw, 3em);
  color: #455a48;
  margin-top: 10px;
`;
